export default __webpack_public_path__ + "2ba7bb0dc40f558687730d6710fa5492.svg";